import { createContext, useContext, useEffect, useState } from "react";
import useTelegramUser from "./useTelegramUser";
import useUserLocation from "./useUserLocation";
import { encrypt } from "../Encypt/xor";
import axios from "axios";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const telegramUserId = useTelegramUser();
  const { location } = useUserLocation();
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!telegramUserId || !location?.latitude || !location?.longitude || userData) return;

    const fetchUserData = async () => {
      try {
        const encryptedPayload = encrypt(telegramUserId);
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/auth?auth_token=${encryptedPayload}&lat=${location.latitude}&lon=${location.longitude}`
        );
        setUserData(response.data);
      } catch (err) {
        setError("You don't have access");
      }
    };

    fetchUserData();
  }, [telegramUserId, location, userData]);

  return (
    <UserContext.Provider value={{ userData, error, location }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
